import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';

/*Services*/
import { StateService, AppService } from '@services';

/*Plugins*/
import { Chart, Highcharts } from 'angular-highcharts';


/*Models */
import { StatsTrack } from '@models';

@Component({
  selector: 'app-graph-stats',
  templateUrl: './graph-stats.component.html'
})

export class GraphStatsComponent implements OnDestroy {
  chartDistance: Chart;
  chartTime: Chart;
  chartSpeed: Chart;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  ifShowGraph = false;
  statsTrackList: Array<StatsTrack>;

  chartYAxisTime = {
    // Формат для часов/минут
    type: 'datetime',
    title: {
      text: null
    },
    labels: {
      formatter: function() {
        const time = this.value;
        let hours = (time / 3600000).toString() ;
        let mins = ((time % 3600000)  / 60000).toString();
        if (hours.length === 1) {
          hours  = '0' + hours;
        }
        if (mins.length === 1) {
          mins  = '0' + mins;
        }
          return  `${hours}:${mins}`;
      }
    }
  };
  chartYAxis = {
    // Формат для обычных данных
    min: 0,
    title: {
      text: null
    },
     labels: {
      formatter: function () {
        return `${this.value}`;
      }
    }
  };
  chartTooltipTime = {
    // Формат для часов/минут
    formatter: function () {

        const time = this.y;
        const hours = parseInt( (time / 3600000).toString() );
        const mins = parseInt((parseInt((time % 3600000).toString())  / 60000).toString());
          return  `<b>${this.x}</b><br/>${this.series.name}: ${hours}:${mins}`;
    }
  };
  chartTooltip = {
    // Формат для обычных данных
    headerFormat: '<b>{point.x}</b><br/>',
    pointFormat: '{series.name}: {point.y}'
  };

  constructor(private stateService: StateService, private appService: AppService) {
    this.stateService.toggleGraphStatsObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe((value: Array<StatsTrack>) => {
        if (value) {
          this.ifShowGraph = true;
          this.statsTrackList = value;

          this.showChartDistance();
          this.showChartTime();
          this.showChartSpeed();

        } else {
          this.ifShowGraph = false;
        }
      });
  }

  showChartDistance() {
    const data = [];
    const legend = [];
    this.parseFormatDataChart(this.statsTrackList, 'distance').map(item => {
      legend.push(this.getDateFormat(item[0]));
      data.push(parseFloat(item[1]));
    });

    // tslint:disable-next-line:max-line-length
    this.chartDistance = this.getChart([{name: 'Расстояние, км', color: '#5ac8fa', data: data}], legend, this.chartYAxis, this.chartTooltip);
  }

  showChartTime() {
    const data = [];
    const legend = [];
    this.parseFormatDataChart(this.statsTrackList, 'travelTime').map(item => {
      legend.push(this.getDateFormat(item[0]));
      data.push(item[1] * 1000);
    });

    // tslint:disable-next-line:max-line-length
    this.chartTime = this.getChart([{name: 'Время в пути', color: '#c7c7cc', data: data }], legend, this.chartYAxisTime, this.chartTooltipTime);
  }

  getDateFormat(date: string) {
    const dateArray = date.split('.');
    return `${dateArray[0]}.${dateArray[1]}`;
  }

  showChartSpeed() {
    const data = [];
    const dataMaxSpeed = [];
    const legend = [];

    this.parseFormatDataChart(this.statsTrackList, 'averageSpeed').map(item => {
      legend.push(this.getDateFormat(item[0]));
      data.push(parseFloat(item[1]));
    });

    this.parseFormatDataChart(this.statsTrackList, 'maxSpeed').map(item => {
      const itemData = item[1];
      dataMaxSpeed.push(itemData);
    });


    this.chartSpeed = this.getChart(
      [
        {name: 'Максимальная скорость, км', color: '#ff9500', data: dataMaxSpeed },
        {name: 'Средняя скорость, км', color: '#007aff', data: data }
      ]
      , legend, this.chartYAxis, this.chartTooltip);
  }

  parseFormatDataChart(array: Array<StatsTrack>, field, notAddFirst?) {
    let dataArray = [];

    array.map((item, index ) => {
      let newItem;
      if (index === 0) {
        newItem = [item.toFormat, item[field], item.toUnix];
      } else {
        newItem = [item.fromFormat, item[field], item.fromUnix];
      }

      if (item.items && item.items.length) {
        dataArray = dataArray.concat(this.parseFormatDataChart(item.items, field, true));
      } else {
        dataArray.push(newItem);
      }
    });
    dataArray = this.appService.sortedArray(dataArray, 2);
    return dataArray;
  }


  getChart(series, legend, yAxis, tooltip) {
    return new Chart({
      chart: {
        type: 'column',
        marginBottom: 50
      },
      title: { style: { 'display': 'none' } },
      xAxis: {
        categories: legend,

      },
      yAxis: yAxis,
      tooltip: tooltip,
      plotOptions: {
        column: {
          grouping: false,
          shadow: false
        }
      },
      series: series
      ,
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/view/components/graph-stats/graph-stats.component.ts